import { render, staticRenderFns } from "./OzDrawerStatic.vue?vue&type=template&id=52b08856&scoped=true&"
import script from "./OzDrawerStatic.vue?vue&type=script&lang=ts&"
export * from "./OzDrawerStatic.vue?vue&type=script&lang=ts&"
import style0 from "./OzDrawerStatic.vue?vue&type=style&index=0&id=52b08856&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b08856",
  null
  
)

export default component.exports